import * as React from "react";
function SvgGhost(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      ref={svgRef}
      {...props}
    >
      <path
        d="M128.85 0a82.67 82.67 0 00-82.7 82.64V205.1l2.2 2.6 20-22.3 20 22.3 20-22.3 20 22.3 20-22.3 20 22.3 20-22.3 20 22.3 1.5-1.6V82.7a82.38 82.38 0 00-81-82.7z"
        fill="#b9b9b9"
      />
      <circle cx={107.05} cy={87.4} r={7.5} fill="#fff" />
      <circle cx={149.85} cy={87.4} r={7.5} fill="#fff" />
      <ellipse
        cx={128.45}
        cy={248.2}
        rx={66.8}
        ry={7.8}
        fill="#d8d8d8"
        opacity={0.5}
        style={{
          isolation: "isolate",
        }}
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgGhost);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
